





















import { defineComponent } from '@vue/composition-api';
import ElSelect            from 'element-ui/lib/select';

export default defineComponent({
  name: 'cSelect',
  components: {
    ElSelect,
  },
});
